export enum InvalidAddressOption {
  ADDRESS = 'street_address',
  CITY = 'city',
  POSTAL_CODE = 'postal_code',
  REGION = 'region',
}

export enum InvalidAddressType {
  ORIGINAL = 'original',
  CUSTOM = 'custom',
}
